import React from 'react';
import { CoreProvider } from 'src/core';
import { BrowserRoutes } from 'src/routes';

export const App = () => (
  <CoreProvider>
    <BrowserRoutes />
  </CoreProvider>
);
